<template>
  <div style="margin-top:-10px;">
    <b-row class="px-pad border-bottom" style="height:42px">
      <b-col md="6" xl="6" lg="6" sm="6" xs="6" cols="6" class="px-0">
        <span class="fw-semi-bold index-heading pl-0">Opening Balance</span>
      </b-col>

      <!-- To get create modal -->
      <b-col md="6" lg="6" sm="6" cols="6" class="text-right px-0">
        <router-link class="event-link float-right" :to="{name:'OpeningBalance'}">
          <i class="la la-remove la-lg text-decoration-none text-dark pt-2 mt-1"></i>
        </router-link>
      </b-col>
    </b-row>
    <b-row style="max-width:1200px;" class="mt-3 pt-1 px-pad">
      <b-col xl="12" lg="12" md="12" sm="12" xs="12" class="px-0">
        <!-- Table for AMC products -->
        <table class="table table-bordered sales-table">
          <thead>
            <th
              width="25%"
            >{{ $route.params.type =='accounts_receivable' ? 'Customer' : 'Vendor' }} Name</th>
            <th width="10%">Currency</th>
            <th width="10%">Exchange Rate</th>
            <th
              width="10%"
              class="text-right"
            >{{ $route.params.type =='accounts_receivable' ? 'Debit' : 'Credit' }}</th>
          </thead>
          <tbody>
            <tr v-if="list.list.length == 0">
              <td colspan="4" class="text-center">No data to display</td>
            </tr>
            <tr v-else v-for="item in list.list" :key="item.id">
              <td style="word-break:break-word !important">
                <router-link
                  v-if="RoutePermission(false,'','','customer','index')"
                  class="event-link theme-text-color"
                  :to="{ name : 'CustomerView',params:{id:item.cus_id}}"
                >{{ item.cus_name }}</router-link>
                <template v-else>{{item.cus_name}}</template>
              </td>
              <td>
                {{ getDetails(
                $AppDetails.currency_details,
                item.currency_id,
                "currency_code"
                ) }}
              </td>
              <td>{{ item.exchage_rate }}</td>
              <td class="text-right">{{ item.bcy_amount }}</td>
            </tr>
            <tr>
              <td class="fw-semi-bold text-right" colspan="3">TOTAL ({{list.total_count}})</td>
              <td class="fw-semi-bold text-right">{{list.total_value}}</td>
            </tr>
          </tbody>
        </table>

        <nav v-if="parseInt(list.total_count) > parseInt(list.show) && list.list.length > 0 ">
          <ul class="pagination float-right" style="cursor:pointer">
            <li
              :style="parseInt(list.page) == 1 ? 'pointer-events:none;opacity : 0.8' : ''"
              class="page-item"
              @click="list.page!=1?getPaginationList(parseInt(list.page) - 1,10):''"
            >
              <span
                aria-hidden="true"
                class="fw-semi-bold fa fa-angle-left mr-2"
                style="margin-bottom : 4px"
              ></span>
            </li>
            <li
              class="page-item"
            >{{ ((list.page - 1) * list.show) + 1 || 0 }} to {{ ((list.page - 1) * list.show) + list.list.length }}</li>

            <li
              :style="list.total_count > (list.page * list.show) ? '' :  'pointer-events:none;opacity : 0.8' "
              class="page-item"
              @click="((list.page - 1) * list.show) + list.list.length<list.total_count?getPaginationList(parseInt(list.page) + 1,10):''"
            >
              <span
                aria-hidden="true"
                class="fw-semi-bold fa fa-angle-right ml-2"
                style="margin-bottom : 4px"
              ></span>
            </li>
          </ul>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  methods: {
    getPaginationList(page, show) {
      this.$store.dispatch("settings/fetchopeningbalancetypedetails", {
        type: this.$route.params.type,
        page: page,
        show: show
      });
    }
  },
  computed: {
    ...mapState({
      list: state => state.settings.list
    })
  }
};
</script>